module.exports = __webpack_public_path__ + "static/media/columnLine.72240897.png";